import React from 'react';

import { bem } from '../utils';

/**
 * Hook that retrieves several utilities for the classnames feature.
 * @param classname - base component clasname
 * @returns utility functions
 */
export const useClassnames = (classname: string) => React.useMemo(() => bem(classname), [classname]);
